module.exports = __webpack_public_path__ + "media/images/icon_nav_amount-10cf16c8037083c125c82b51f668f2ec.svg";